module.exports = "<svg id=\"a8606e67-ea01-4559-9698-a521a908f6c7\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.24 50\"><title>location-option</title><path d=\"M24.88.16a16.75,16.75,0,0,0-17.09,17A19.75,19.75,0,0,0,9.2,23.53C14,33.89,17.71,39.78,24.91,50.16,32.21,39.3,36.25,33.8,41,23.53a19.66,19.66,0,0,0,1-6.36A16.8,16.8,0,0,0,24.88.16ZM24.76,27.7a10.39,10.39,0,1,1,10.3-10.39A10.34,10.34,0,0,1,24.76,27.7Z\" transform=\"translate(-7.79 -0.16)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-option.svg
// module id = 506
// module chunks = 1